import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
 constructor(private  spinner:NgxSpinnerService) { }
   // Show the spinner
  show(): void {
    this.spinner.show();
  }

  // Hide the spinner
  hide(): void {
    this.spinner.hide();
  }
}
